var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardTitleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12251_53152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 24.8C17.1282 24.8 17.7998 24.1284 17.7998 23.3C17.7998 22.4716 17.1282 21.8 16.2998 21.8C15.4714 21.8 14.7998 22.4716 14.7998 23.3C14.7998 24.1284 15.4714 24.8 16.2998 24.8Z",
    fill: "#42296E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 18.8V17.8C18.5086 17.8 20.2998 16.2325 20.2998 14.3C20.2998 12.3675 18.5086 10.8 16.2998 10.8C14.0911 10.8 12.2998 12.3675 12.2998 14.3V14.8",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2998 28.8C22.9272 28.8 28.2998 23.4274 28.2998 16.8C28.2998 10.1726 22.9272 4.79999 16.2998 4.79999C9.67239 4.79999 4.2998 10.1726 4.2998 16.8C4.2998 23.4274 9.67239 28.8 16.2998 28.8Z",
    stroke: "#42296E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12251_53152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.299805 0.799988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardTitleIcon);
export default __webpack_public_path__ + "static/media/cardTitleIcon.723400008ae0bfbc25a904da587089dc.svg";
export { ForwardRef as ReactComponent };